<template>
  <div id="contenedor-estadisticas-listado-detalle">
    <v-simple-table>
      <template
        v-slot:default>
        <thead>
          <tr>
            <th>Número</th>
            <th>Objeto</th>
            <th>Supervisor</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="contrato in listado">
            <template>
              <tr
                :key="contrato.id">
                <td class="font-weight-bold">
                  {{ contrato.numero }}
                </td>
                <td>
                  <cortar-texto
                    :texto="contrato.meta"
                    :cantidad-caracteres="75">
                  </cortar-texto>
                </td>
                <td>
                  <template
                    v-if="getSupervisor(contrato)">
                    {{ getSupervisor(contrato).funcionario.nombre }}
                  </template>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'EstadisticaConsultaListadoDetalles',
  components: {
    CortarTexto,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getSupervisor(contrato) {
      if (!contrato.responsables) return null;
      const supervisor = contrato.responsables
        .find((responsable) => responsable.principal === true);

      return supervisor;
    },
  },
};
</script>

<style lang="scss">

</style>
